import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from 'react-bootstrap';
import AccessControl from '../services/access-control';

import NavbarUserBlock from './common/navbar/navbar-user-block';
import NavbarPageTitle from './common/navbar/navbar-page-title';

import sidebarLogo from '../img/sidebar-logo.png';
import Logo from '../img/logo.png';

class Header extends Component {

  renderNavbarLogo() {
    const { pathname } = this.props.location;
    const pathToLogo = /^\/public($|\/$)/.test(pathname) ? sidebarLogo : Logo;

    if (!AccessControl.can('view', 'sidebar')) {
      return (
        <Navbar.Header className="header__logo-logout-wrapper">
          <Navbar.Brand>
            <Link to='/'>
              <img className="img-responsive hidden-xs" src={pathToLogo} alt="Logo" />
              <img className="img-responsive hidden-sm hidden-md hidden-lg" src={Logo} alt="Logo" />
            </Link>
          </Navbar.Brand>
        </Navbar.Header>
      );
    }

    return null;
  }

  render() {
    const { location } = this.props;

    return (
      <header className="app-navbar">
        <Navbar>
          { this.renderNavbarLogo() }
          <NavbarPageTitle />
          <NavbarUserBlock pathname={location.pathname} />
        </Navbar>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js